const API_BASE_URL = "https://student-portal-backend-dyg7.onrender.com";

export default API_BASE_URL;
